import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { IUserInterfaceState } from "../../../../features/ui/store/ui.reducer";
import { goToLogin } from "../../../../features/navigation/services/navigation.service";
import { createEmptyError, IError } from "../../../../redux/actions/errorHandlingAction";
import { UserData } from "../../types/user-data.interface";
import { createUserData } from "../../types/user-data.functions";
import { ForgotPasswordView } from "../forgot-password-view/forgot-password-view.component";
import InfoMessages from "../../../../components/infoMessages";
import * as userStore from "../../../../features/user/store/user.store";

export const ForgotPassword = () => {
  const { loading: uiLoading, errors: uiErrors } = useSelector(
    (state: IUserInterfaceState) => state.UI
  );

  const [userDataValues, setUserDataValues] = useState<UserData>(createUserData());

  const [errors, setErrors] = useState<IError>(createEmptyError());
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (uiErrors) {
      setErrors(uiErrors);
    }
    setLoading(uiLoading);
  }, [uiErrors, uiLoading]);

  const handleSubmit = (e: any) => {
    e.preventDefault();
    setLoading(true);

    userStore.resetPassword(createUserData(userDataValues.email));
  };

  const handleChange = (e: any) => {
    e.persist();
    setUserDataValues((values: any) => ({
      ...values,
      [e.target.name]: e.target.value,
    }));
  };

  const handleBackToLogin = (e: any) => goToLogin();

  return (
    <>
      <InfoMessages />
      <ForgotPasswordView
        userDataValues={userDataValues}
        errors={errors}
        loading={loading}
        onChange={handleChange}
        onSubmit={handleSubmit}
        onBackToLogin={handleBackToLogin}
      />
    </>
  );
};
